<template>
  <div>
    <a v-for="(item,index) in srclist" :href="`${baseUrl}${item}`"  :underline="false" target="_blank">

      <van-button plain type="primary">{{getname(item)}}</van-button>
      </a>
  </div>
</template>

<script>
export default {
  name: 'FileDownload',
  props: {
    srcs: {
      type: String,
      default: null
    }

  },
  data () {
    return {
      baseUrl: 'http://wx2.hunanzongdui.cn',
      srclist: []
    }
  },
  created () {
    if (this.srcs) {
      this.srclist = this.srcs.split(',')
    }
  },
  methods: {
    getname (str) {
      // console.log("--->",str,str.lastIndexOf('/'),str.indexOf('_'),str.substr(str.lastIndexOf('/'),str.indexOf('_')))
      return str.substring(str.lastIndexOf('/') + 1, str.indexOf('_'))
    }
  }

}
</script>
<style scoped>
.el-tag + .el-tag {
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/FileDownload/index.vue